<template>
	<UserRegistrationLayout hidePendingInstall>
		<InstallationCompleteContent :wfId="wfId" />
	</UserRegistrationLayout>
</template>

<script>
import InstallationCompleteContent from '@/views/InstallationCompleteContent.vue';
import UserRegistrationLayout from '@/views/userRegistration/UserRegistrationLayout';
export default {
	name: 'InstallationComplete',
	props: {
		wfId: { type: Number },
	},
	components: {
		UserRegistrationLayout,
		InstallationCompleteContent,
	},
	computed: {},
	methods: {},
};
</script>
<style scoped lang="scss"></style>
